import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="pt-24 sm:pt-28 md:pt-36 pb-16 px-4 sm:px-6 md:px-12 lg:px-20 max-w-5xl mx-auto">
            <h1 className="tracking-wide font-thin md:font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-8 sm:mb-12">
                PRIVACY POLICY
            </h1>
            <div className="space-y-8 text-gray-700 leading-relaxed text-sm sm:text-base">
                <div className="pb-4">
                    <p className="mb-3">
                        This privacy policy outlines how we handle the processing of personal information you provide to us. We will notify you of any changes in the processing of your information.
                    </p>
                    <p>
                        You can navigate our website and access our home page without disclosing personal data, except for information collected by cookies (refer to the section below).
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Who may process data</h2>
                    <p>
                        Your personal information, including your name and address, may be processed by us and other companies within our group. Our website contains a link to Rackspace, and this company may also collect personal data from site visitors. All authorized companies processing your information will adhere to this privacy policy.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Purpose of processing</h2>
                    <p>
                        We will use your information to fulfill service orders, process authorized transactions, inform you of special offers, provide marketing information, and conduct customer research/development.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Disclosure of Information</h2>
                    <p>
                        In rare circumstances involving liquidation, administration, or receivership, a third-party purchaser of the business may receive your information, provided they agree to use it for the same purposes outlined in this policy. We commit not to disclose your personal information to third parties, except as specified in this policy. Your information will not be shared with government or local authorities, except as required by law.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Cookies</h2>
                    <p>
                        When you visit our website, a small file may be sent to your computer to identify it, track your behavior, and identify your areas of interest. This helps enhance your future visits. We may collect and store personal data through cookies, linking this information with data you provide. Apart from the use of cookies, we do not automatically log or collect data unless explicitly provided by you. You can configure your browser to reject cookies, but this may limit your use of certain website features.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
